export * from './menu/actions';
export * from './settings/actions';
export * from './status/actions';

export const LIMPIAR_MENSAJE = 'LIMPIAR_MENSAJE';
export const MSG_SUCCESS = 'MSG_SUCCESS';
export const MSG_ERROR = 'MSG_ERROR';
export const MSG_ADVERTENCIA = 'MSG_ADVERTENCIA';
export const MSG_INFORMACION = 'MSG_INFORMACION';
export const LOADING = 'LOADING';

export const msgInformacion = (mensaje) => ({
  type: MSG_INFORMACION,
  payload: { mensaje },
});

export const msgAdvertencia = (mensaje) => ({
  type: MSG_ADVERTENCIA,
  payload: { mensaje },
});

export const msgError = (mensaje) => ({
  type: MSG_ERROR,
  payload: { mensaje },
});

export const msgSuccess = (mensaje) => ({
  type: MSG_SUCCESS,
  payload: { mensaje },
});

export const limpiarMensaje = () => ({
  type: LIMPIAR_MENSAJE,
});

export const loading = (bool = true) => ({
  type: LOADING,
  payload: bool,
});
